import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerDetails, getCustomerMealPlans, getMealPlanDetail, getCustomerOrders, getOrderDetail, getCustomerBills, getBillDetail, getCustomerVerification, downloadOrderBillPdf, cancelCustomerOrder } from "../redux/Thunk/customerThunk";
import CustomerProviderCard from "../components/CustomerProviderCard";
import DinnerMoonIcon from "../components/DinnerMoonIcon";
import LunchSunIcon from "../components/LunchSunIcon";
import VerificationModal from "../components/VerificationModalPremium";
import Toolbar from "../components/Toolbar";
import OrdersTable from "../components/OrdersTable";
import InvoiceTable from "../components/InvoiceTable";
import SubscriptionsTable from "../components/SubscriptionsTable";
import {
  AddOrderModal,
  CancelOrderModal,
  OrderDetailsDrawer,
  InvoiceDetailsModal,
  MealPlanDetailModal
} from "../components/ModalsPremium";
import toast from "react-hot-toast";
import EnvironmentTag from "../components/Tag/EnvironmentTag";
import {
  TableRowSkeleton,
  StatCardSkeleton,
  OrdersTableSkeleton,
  InvoiceTableSkeleton,
  SubscriptionsTableSkeleton,
  PageSkeleton
} from "../components/SkeletonLoader";
import {
  Calendar,
  Clock,
  AlertCircle,
  Receipt,
  ShoppingBag,
  CheckCircle2,
  ChevronLeft,
  ChevronRight,
  Info,
  Sun,
  Moon,
  Star
} from "lucide-react";

// Custom Invoice SVG Icon
const InvoiceCustomIcon = ({ className = "w-4 h-4", ...props }) => (
  <svg
    viewBox="0 0 1024 1024"
    className={className}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M731.15 585.97c-100.99 0-182.86 81.87-182.86 182.86s81.87 182.86 182.86 182.86 182.86-81.87 182.86-182.86-81.87-182.86-182.86-182.86z m0 292.57c-60.5 0-109.71-49.22-109.71-109.71s49.22-109.71 109.71-109.71c60.5 0 109.71 49.22 109.71 109.71s-49.21 109.71-109.71 109.71z"
      fill="currentColor"
    />
    <path
      d="M718.01 778.55l-42.56-38.12-36.6 40.86 84.02 75.26 102.98-118.46-41.4-36zM219.51 474.96h219.43v73.14H219.51z"
      fill="currentColor"
    />
    <path
      d="M182.61 365.86h585.62v179.48h73.14V145.21c0-39.96-32.5-72.48-72.46-72.48h-27.36c-29.18 0-55.04 16.73-65.88 42.59-5.71 13.64-27.82 13.66-33.57-0.02-10.86-25.86-36.71-42.57-65.88-42.57h-18.16c-29.18 0-55.04 16.73-65.88 42.59-5.71 13.64-27.82 13.66-33.57-0.02-10.86-25.86-36.71-42.57-65.88-42.57H375.3c-29.18 0-55.04 16.73-65.88 42.59-5.71 13.64-27.82 13.66-33.57-0.02-10.86-25.86-36.71-42.57-65.88-42.57H182.4c-39.96 0-72.48 32.52-72.48 72.48v805.14h401.21v-73.14H183.04l-0.43-511.35z m25.81-222.29c14.25 34.09 47.32 56.11 84.23 56.11 36.89 0 69.96-22.02 82.66-53.8l15.86-2.3c14.25 34.09 47.32 56.11 84.23 56.11 36.89 0 69.96-22.02 82.66-53.8l16.59-2.3c14.25 34.09 47.32 56.11 84.23 56.11 36.89 0 69.96-22.02 82.66-53.8l26.68-0.66v147.5H182.54l-0.13-146.84 26.01-2.33z"
      fill="currentColor"
    />
  </svg>
);

// Custom Today's Order SVG Icon
const TodaysOrderCustomIcon = ({ className = "w-3 h-3", ...props }) => (
  <svg
    viewBox="0 0 512 512"
    className={className}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M50.57,55.239C27.758,29.036-13.992,53.833,4.68,95.145c12.438,27.563,36.469,94.922,70.016,143.438 c33.563,48.516,69.328,43.328,105.453,55.078l25.953,13.422l177.547,204.204l35.906-31.234l0.188-0.156 c-5.25-6.047-166.719-191.782-230.563-265.204C125.992,142.02,61.664,68.004,50.57,55.239z" fill="currentColor" />
      <path d="M476.664,93.551l-61.938,71.266c-3.969,4.563-10.859,5.031-15.422,1.063l-2.203-1.906 c-4.531-3.953-5.031-10.844-1.063-15.406l62.234-71.594c10.219-11.734,5.375-22.125-2.219-28.719 c-7.578-6.578-18.531-9.938-28.75,1.813l-62.234,71.594c-3.953,4.547-10.859,5.031-15.406,1.063l-2.188-1.906 c-4.563-3.953-5.047-10.859-1.094-15.406l61.953-71.266c18.297-21.031-12.297-46.375-30.156-25.828 c-21.391,24.594-59.156,68.031-59.156,68.031c-33,37.688-32.5,55.344-27.844,80.078c3.781,19.938,9.328,34.281-11.156,57.844 l-30.234,34.781l31.719,36.453l34.641-39.844c20.469-23.547,35.453-20.047,55.719-19.094c25.156,1.203,42.703-0.766,75.422-38.672 c0,0,37.766-43.469,59.156-68.063C524.305,99.286,494.945,72.536,476.664,93.551z" fill="currentColor" />
      <polygon points="185.758,322.692 49.102,479.88 85.211,511.286 219.055,357.348 191.508,325.661 " fill="currentColor" />
    </g>
  </svg>
);

export default function CustomerPortal() {
  const { customerId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Redux state
  const {
    isCustomerLoading,
    customerData: fetchedCustomerData,
    isMealPlansLoading,
    mealPlansData,
    isPlanDetailLoading,
    planDetailData,
    isOrdersLoading,
    ordersData,
    ordersMeta,
    isOrderDetailLoading,
    orderDetailData,
    isBillsLoading,
    billsData,
    isBillDetailLoading,
    billDetailData,
    isVerificationLoading,
    verificationData
  } = useSelector((state) => state.customer);

  // --- App Data States ---
  const [customer, setCustomer] = useState({
    name: "",
    id: customerId || "",
    email: "",
    phone: "",
    address: "",
    initials: "",
    isVerified: false,
    avatarUrl: ""
  });
  const [provider, setProvider] = useState({
    name: "",
    id: "",
    email: "",
    phone: "",
    address: "",
    logo: "",
    logoUrl: ""
  });
  const [todayOrders, setTodayOrders] = useState([]);
  const [orderHistory, setOrderHistory] = useState([]);
  const [invoices, setInvoices] = useState([]);

  const availableMeals = mealPlansData && mealPlansData.length > 0
    ? mealPlansData.map((plan) => ({
      id: plan.meal_plan_id,
      name: plan.meal_name,
      category: plan.meal_type ? plan.meal_type.charAt(0).toUpperCase() + plan.meal_type.slice(1) : "Lunch",
      price: plan.total_amount ? (plan.total_amount / 30) : 10,
      image: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&w=120&q=80",
      description: `${plan.meal_name} under subscription plan ${plan.meal_plan_unique_id}`
    }))
    : [];

  // --- Cutoff Timer State ---
  const [timerMode, setTimerMode] = useState("active"); // active, warning, closed
  const [timeLeft, setTimeLeft] = useState("02:48:36");
  const [lunchTimeLeft, setLunchTimeLeft] = useState("");
  const [isLunchPassed, setIsLunchPassed] = useState(false);
  const [dinnerTimeLeft, setDinnerTimeLeft] = useState("");
  const [isDinnerPassed, setIsDinnerPassed] = useState(false);

  // --- Active Tab State ---
  const [activeTab, setActiveTab] = useState(1); // 1: Today's Orders, 2: History, 3: Invoices

  // --- Modals Toggle States ---
  const [verifyModalOpen, setVerifyModalOpen] = useState(false);
  const [addOrderModalOpen, setAddOrderModalOpen] = useState(false);
  const [preselectedMeal, setPreselectedMeal] = useState(null);
  const [cancelModalOpen, setCancelModalOpen] = useState(false);
  const [selectedOrderForCancel, setSelectedOrderForCancel] = useState(null);
  const [detailsDrawerOpen, setDetailsDrawerOpen] = useState(false);
  const [selectedOrderForDetails, setSelectedOrderForDetails] = useState(null);
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const [selectedInvoiceForDetails, setSelectedInvoiceForDetails] = useState(null);
  const [subscriptionsModalOpen, setSubscriptionsModalOpen] = useState(false);

  // --- Search, Filter & Sort States ---
  // Tab 1 Today
  const [todaySearch, setTodaySearch] = useState("");
  const [todayFilter, setTodayFilter] = useState("all");
  const [todaySort, setTodaySort] = useState("newest");
  const [todaySubtab, setTodaySubtab] = useState("lunch");

  // Tab 2 History
  const [historySearch, setHistorySearch] = useState("");
  const [historyFilter, setHistoryFilter] = useState("all"); // category
  const [historySort, setHistorySort] = useState("newest");
  const [historySubtab, setHistorySubtab] = useState("all"); // all, pending, completed, cancelled
  const [historyDateRange, setHistoryDateRange] = useState({ start: "", end: "" });

  // --- Pagination States ---
  const [lunchPage, setLunchPage] = useState(1);
  const [dinnerPage, setDinnerPage] = useState(1);
  const [historyPage, setHistoryPage] = useState(1);
  const [subscriptionsPage, setSubscriptionsPage] = useState(1);
  const [invoicesPage, setInvoicesPage] = useState(1);

  // Reset pagination when active tab, subtabs, search, filters or date ranges change
  useEffect(() => {
    setLunchPage(1);
    setDinnerPage(1);
    setHistoryPage(1);
    setSubscriptionsPage(1);
    setInvoicesPage(1);
  }, [
    activeTab,
    todaySubtab,
    todaySearch,
    todayFilter,
    historySubtab,
    historySearch,
    historyFilter,
    historyDateRange.start,
    historyDateRange.end,
    customerId
  ]);

  // Helper for smart pagination numbers with ellipsis (1 2 ... 5 ... 136)
  const getPageNumbers = (current, total) => {
    if (total <= 4) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    const pages = new Set();
    pages.add(1);
    pages.add(2);

    if (current - 1 > 1) pages.add(current - 1);
    pages.add(current);
    if (current + 1 < total) pages.add(current + 1);

    pages.add(total);

    const sortedPages = Array.from(pages).sort((a, b) => a - b);
    const result = [];
    let prev = null;

    for (const page of sortedPages) {
      if (prev !== null) {
        if (page - prev === 2) {
          result.push(prev + 1);
        } else if (page - prev > 2) {
          result.push("...");
        }
      }
      result.push(page);
      prev = page;
    }

    return result;
  };

  // Reusable Pagination UI Helper
  const renderPaginationControls = (currentPage, totalPages, onPageChange) => {
    if (totalPages <= 1) return null;

    const pageNumbers = getPageNumbers(currentPage, totalPages);

    return (
      <div className="flex items-center justify-between border-t border-border-primary/60 px-4 py-3.5 bg-white sm:px-6 rounded-b-xl mt-3 select-none">
        <div className="flex flex-1 justify-between sm:hidden">
          <button
            onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
            disabled={currentPage === 1}
            className="relative inline-flex items-center rounded-xl border border-border-primary/80 bg-white px-4 py-2 text-xs font-bold text-text-secondary hover:bg-bg-secondary disabled:opacity-50 disabled:hover:bg-white transition-all cursor-pointer"
          >
            Previous
          </button>
          <button
            onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
            disabled={currentPage === totalPages}
            className="relative ml-3 inline-flex items-center rounded-xl border border-border-primary/80 bg-white px-4 py-2 text-xs font-bold text-text-secondary hover:bg-bg-secondary disabled:opacity-50 disabled:hover:bg-white transition-all cursor-pointer"
          >
            Next
          </button>
        </div>
        <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between gap-4">
          <div>
            <p className="text-xs text-text-secondary">
              Showing page <span className="font-bold text-text-primary">{currentPage}</span> of{" "}
              <span className="font-bold text-text-primary">{totalPages}</span>
            </p>
          </div>
          <div>
            <nav className="isolate inline-flex items-center space-x-0.5 rounded-xl shadow-2xs bg-bg-secondary/40 p-0.5" aria-label="Pagination">
              <button
                onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
                disabled={currentPage === 1}
                className="relative inline-flex items-center rounded-lg px-2 py-1.5 text-text-secondary hover:bg-white hover:text-text-primary disabled:opacity-30 disabled:hover:bg-transparent transition-all cursor-pointer"
              >
                <span className="sr-only">Previous</span>
                <ChevronLeft className="h-4 w-4" aria-hidden="true" />
              </button>

              {pageNumbers.map((page, idx) =>
                page === "..." ? (
                  <span
                    key={`dots-${idx}`}
                    className="px-2 py-1 text-xs text-text-secondary font-bold select-none cursor-default"
                  >
                    ...
                  </span>
                ) : (
                  <button
                    key={page}
                    onClick={() => onPageChange(page)}
                    className={`relative inline-flex items-center rounded-lg px-3 py-1.5 text-xs font-bold transition-all cursor-pointer ${page === currentPage
                      ? "bg-white text-brand-red shadow-xs font-extrabold"
                      : "text-text-secondary hover:bg-white/50 hover:text-text-primary"
                      }`}
                  >
                    {page}
                  </button>
                )
              )}

              <button
                onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="relative inline-flex items-center rounded-lg px-2 py-1.5 text-text-secondary hover:bg-white hover:text-text-primary disabled:opacity-30 disabled:hover:bg-transparent transition-all cursor-pointer"
              >
                <span className="sr-only">Next</span>
                <ChevronRight className="h-4 w-4" aria-hidden="true" />
              </button>
            </nav>
          </div>
        </div>
      </div>
    );
  };



  // --- Date state for Today's display ---
  const [currentDateFormatted, setCurrentDateFormatted] = useState("");

  useEffect(() => {
    const d = new Date();
    const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
    setCurrentDateFormatted(d.toLocaleDateString('en-US', options));
  }, []);

  // Fetch customer details on mount / customerId change
  useEffect(() => {
    if (customerId) {
      dispatch(getCustomerDetails({ token: customerId }))
        .unwrap()
        .then(() => {
          dispatch(getCustomerMealPlans({ token: customerId }));
          dispatch(getCustomerOrders({ token: customerId, perPage: 10 }));
          dispatch(getCustomerBills({ token: customerId }));
          dispatch(getCustomerVerification({ token: customerId }));
        })
        .catch(() => {
          navigate("/not-found", { replace: true });
        });
    }
  }, [customerId, dispatch, navigate]);

  // Fetch Orders dynamically based on Active Tab & History Pagination / Filters
  useEffect(() => {
    if (customerId) {
      if (activeTab === 2) {
        dispatch(
          getCustomerOrders({
            token: customerId,
            page: historyPage,
            perPage: 10,
            status: historySubtab !== "all" ? historySubtab : undefined,
            orderCategory: historyFilter !== "all" ? historyFilter : undefined,
            startDate: historyDateRange.start || undefined,
            endDate: historyDateRange.end || undefined,
            search: historySearch || undefined
          })
        );
      } else if (activeTab === 1) {
        dispatch(
          getCustomerOrders({
            token: customerId,
            perPage: 10
          })
        );
      }
    }
  }, [
    customerId,
    activeTab,
    historyPage,
    historySubtab,
    historyFilter,
    historyDateRange.start,
    historyDateRange.end,
    historySearch,
    dispatch
  ]);

  // Sync fetched customer details
  useEffect(() => {
    if (fetchedCustomerData) {
      setCustomer({
        name: fetchedCustomerData.customer_name || "",
        id: fetchedCustomerData.customer_id || customerId,
        email: fetchedCustomerData.email || "",
        phone: fetchedCustomerData.contact_no
          ? `+${fetchedCustomerData.country_code || "91"} ${fetchedCustomerData.contact_no}`
          : "",
        isVerified: fetchedCustomerData.is_verify === 1,
        current_balance: fetchedCustomerData.current_balance || 0,
        balance_type: fetchedCustomerData.balance_type || "due",
        initials: fetchedCustomerData.customer_name
          ? fetchedCustomerData.customer_name
            .split(" ")
            .map((n) => n[0])
            .join("")
            .toUpperCase()
            .slice(0, 2)
          : "CS",
        avatarUrl: fetchedCustomerData.provider?.personal_details?.profile_image || "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=120&q=80"
      });

      if (fetchedCustomerData.provider) {
        const p = fetchedCustomerData.provider;
        const pd = p.personal_details || {};
        const sd = p.service_details || {};
        setProvider({
          name: sd.service_name || pd.name || "TiffinTap Kitchen",
          ownerName: pd.name || "",
          id: sd.provider_unique_id || pd.raw_service_provider_id || "",
          email: pd.email || "",
          phone: pd.contact_no
            ? `+${pd.country_code || "91"} ${pd.contact_no}`
            : "",
          address: sd.address_1 || "",
          logo: (sd.service_name || pd.name || "T").charAt(0).toUpperCase(),
          logoUrl: sd.profile_image || pd.profile_image || "",
          description: sd.description || "",
          cuisines: sd.cuisines || [],
          foodType: sd.food_type_name || "",
          deliveryType: sd.delivery_type_name || "",
          operatingDays: sd.operating_days || [],
          lunchTime: sd.lunch_time_from && sd.lunch_time_to ? `${sd.lunch_time_from} - ${sd.lunch_time_to}` : "",
          dinnerTime: sd.dinner_time_from && sd.dinner_time_to ? `${sd.dinner_time_from} - ${sd.dinner_time_to}` : "",
          currencySymbol: sd.currency_symbol || pd.currency_symbol || "",
          qrLink: sd.qr_link || ""
        });
      }
    }
  }, [fetchedCustomerData, customerId]);

  // Sync verification status from verificationData if loaded
  useEffect(() => {
    if (verificationData) {
      setCustomer(prev => ({
        ...prev,
        isVerified: verificationData.is_verify === 1
      }));
    }
  }, [verificationData]);

  const normalizeDateStr = (dateVal) => {
    if (!dateVal) return "";
    let str = String(dateVal).trim();
    if (str.includes("T")) str = str.split("T")[0];
    if (str.includes(" ")) str = str.split(" ")[0];

    if (str.includes("-")) {
      const parts = str.split("-");
      if (parts.length === 3) {
        if (parts[0].length === 4) {
          return `${parts[0]}-${parts[1].padStart(2, "0")}-${parts[2].padStart(2, "0")}`;
        } else if (parts[2].length === 4) {
          return `${parts[2]}-${parts[1].padStart(2, "0")}-${parts[0].padStart(2, "0")}`;
        }
      }
    }
    if (str.includes("/")) {
      const parts = str.split("/");
      if (parts.length === 3) {
        if (parts[0].length === 4) {
          return `${parts[0]}-${parts[1].padStart(2, "0")}-${parts[2].padStart(2, "0")}`;
        } else if (parts[2].length === 4) {
          return `${parts[2]}-${parts[1].padStart(2, "0")}-${parts[0].padStart(2, "0")}`;
        }
      }
    }
    return str;
  };

  const getTodayDateString = () => {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Sync fetched customer orders into todayOrders and orderHistory
  useEffect(() => {
    if (ordersData && Array.isArray(ordersData)) {
      const todayStr = getTodayDateString();

      const mapped = ordersData.map((order, idx) => {
        const orderIdVal = String(
          order.order_unique_id ||
          order.order_id ||
          order.unique_order_id ||
          order.raw_order_id ||
          order.id ||
          `ORD-${idx + 1}`
        );

        let rawDate = order.order_date || "";
        if (rawDate.includes("T")) rawDate = rawDate.split("T")[0];
        if (rawDate.includes(" ")) rawDate = rawDate.split(" ")[0];

        const normDate = normalizeDateStr(order.order_date);

        return {
          id: orderIdVal,
          order_id: order.order_id || orderIdVal,
          raw_order_id: order.raw_order_id || order.order_id || orderIdVal,
          mealId: order.meal_id,
          raw_meal_id: order.raw_meal_id,
          name: order.meal_name || "Meal Order",
          category: order.meal_type ? order.meal_type.charAt(0).toUpperCase() + order.meal_type.slice(1) : "",
          price: (order.total_amount || 0) / (order.quantity || 1) / 30, // matches price * 30 calculation in table
          quantity: order.quantity || 1,
          total: order.total_amount || 0,
          status: order.status ? order.status.charAt(0).toUpperCase() + order.status.slice(1) : "Pending",
          orderDate: rawDate,
          normalizedDate: normDate,
          orderTime: order.time_slot || "",
          time_slot: order.time_slot || "",
          delivery_preference: order.delivery_preference || "",
          is_meal_plan_order: order.is_meal_plan_order,
          raw: order
        };
      });

      // Update todayOrders only if we are not fetching a filtered/paginated Order History subset
      const isFilteredHistoryFetch =
        activeTab === 2 &&
        (historySubtab !== "all" ||
          historyFilter !== "all" ||
          historyPage > 1 ||
          Boolean(historySearch) ||
          Boolean(historyDateRange?.start));

      if (!isFilteredHistoryFetch) {
        const todayList = mapped.filter((o) => o.normalizedDate === todayStr);
        setTodayOrders(todayList);
      }
      setOrderHistory(mapped);
    }
  }, [ordersData, activeTab, historySubtab, historyFilter, historyPage, historySearch, historyDateRange]);

  // --- Real-time Countdown timer based on provider cutoff times ---
  useEffect(() => {
    const sd = fetchedCustomerData?.provider?.service_details || {};
    const lunchCutoff = sd.lunch_cutoff_time || "14:15";
    const dinnerCutoff = sd.dinner_cutoff_time || "21:15";

    const updateTimers = () => {
      const now = new Date();
      const [lh, lm] = lunchCutoff.split(":").map(Number);
      const [dh, dm] = dinnerCutoff.split(":").map(Number);

      const lunchDate = new Date();
      lunchDate.setHours(lh, lm, 0, 0);

      const dinnerDate = new Date();
      dinnerDate.setHours(dh, dm, 0, 0);

      const pad = (num) => String(num).padStart(2, "0");

      // Lunch Timer
      if (now.getTime() >= lunchDate.getTime()) {
        setIsLunchPassed(true);
        setLunchTimeLeft("Cutoff Passed");
      } else {
        setIsLunchPassed(false);
        const diffMs = lunchDate.getTime() - now.getTime();
        const diffSecs = Math.floor(diffMs / 1000);
        const h = Math.floor(diffSecs / 3600);
        const m = Math.floor((diffSecs % 3600) / 60);
        const s = diffSecs % 60;
        setLunchTimeLeft(`${pad(h)}:${pad(m)}:${pad(s)}`);
      }

      // Dinner Timer
      if (now.getTime() >= dinnerDate.getTime()) {
        setIsDinnerPassed(true);
        setDinnerTimeLeft("Cutoff Passed");
      } else {
        setIsDinnerPassed(false);
        const diffMs = dinnerDate.getTime() - now.getTime();
        const diffSecs = Math.floor(diffMs / 1000);
        const h = Math.floor(diffSecs / 3600);
        const m = Math.floor((diffSecs % 3600) / 60);
        const s = diffSecs % 60;
        setDinnerTimeLeft(`${pad(h)}:${pad(m)}:${pad(s)}`);
      }
    };

    updateTimers(); // run once immediately
    const interval = setInterval(updateTimers, 1000);

    return () => clearInterval(interval);
  }, [fetchedCustomerData]);

  const getActiveCutoffTimeStr = () => {
    const sd = fetchedCustomerData?.provider?.service_details || {};
    const lunchCutoff = sd.lunch_cutoff_time || "14:15";
    const dinnerCutoff = sd.dinner_cutoff_time || "21:15";

    const now = new Date();
    const [lh, lm] = lunchCutoff.split(":").map(Number);
    const [dh, dm] = dinnerCutoff.split(":").map(Number);

    const lunchDate = new Date();
    lunchDate.setHours(lh, lm, 0, 0);

    const dinnerDate = new Date();
    dinnerDate.setHours(dh, dm, 0, 0);

    if (now.getTime() < lunchDate.getTime()) {
      return lunchCutoff;
    } else if (now.getTime() < dinnerDate.getTime()) {
      return dinnerCutoff;
    } else {
      return lunchCutoff;
    }
  };

  const activeCutoffTimeStr = getActiveCutoffTimeStr();
  const serviceDetails = fetchedCustomerData?.provider?.service_details || {};
  const lunchCutoffTime = serviceDetails.lunch_cutoff_time || "14:15";
  const dinnerCutoffTime = serviceDetails.dinner_cutoff_time || "21:15";

  const formatCutoffTime = (timeStr) => {
    if (!timeStr) return "12:00 PM";
    const parts = timeStr.split(":");
    let h = parseInt(parts[0], 10);
    const m = parts[1] || "00";
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12;
    h = h ? h : 12; // the hour '0' should be '12'
    return `${String(h).padStart(2, "0")}:${m} ${ampm}`;
  };

  // --- Workflows ---

  // 1. Account verification success
  const handleVerificationSuccess = () => {
    setCustomer(prev => ({ ...prev, isVerified: true }));
    toast.success("Account verified successfully.");
    dispatch(getCustomerVerification({ token: customerId }));
  };

  // 2. Cancellation submission via API
  const handleCancelSubmit = (order, cancellationReason = "Changed my mind") => {
    const rawId = order?.raw?.raw_order_id || order?.raw_order_id || order?.id;
    if (!rawId) {
      toast.error("Order ID not found.");
      return;
    }

    const toastId = toast.loading("Cancelling order...");

    dispatch(
      cancelCustomerOrder({
        token: customerId,
        orderId: rawId,
        isConfirmed: 1,
        cancellationReason: cancellationReason,
      })
    )
      .unwrap()
      .then((res) => {
        toast.success(res?.message || "Order cancelled successfully.", { id: toastId });
        setCancelModalOpen(false);
        setSelectedOrderForCancel(null);

        // Refresh customer orders list from backend
        dispatch(getCustomerOrders({ token: customerId }));
      })
      .catch((err) => {
        console.error("Cancel order error:", err);
        const errMsg = typeof err === "string" ? err : (err?.message || "Failed to cancel order.");
        toast.error(errMsg, { id: toastId });
      });
  };

  // 3. Placing a new order
  const handleAddOrderSubmit = (newMealData) => {
    const orderId = `ORD-${Math.floor(Math.random() * 90000) + 10000}`;
    const orderTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });

    const newOrderObj = {
      id: orderId,
      mealId: newMealData.mealId,
      name: newMealData.name,
      category: newMealData.category,
      price: newMealData.price,
      quantity: newMealData.quantity,
      total: newMealData.total,
      status: "Confirmed",
      orderTime: orderTime,
      image: newMealData.image,
      description: newMealData.description
    };

    setTodayOrders(prev => [newOrderObj, ...prev]);

    // Also update history list
    const orderDate = new Date().toISOString().split('T')[0];
    setOrderHistory(prev => [
      {
        ...newOrderObj,
        status: "Completed",
        orderDate: orderDate
      },
      ...prev
    ]);

    // Update pending invoice amount
    setInvoices(prev => prev.map(inv => {
      if (inv.id === "INV-10292") {
        // If meal already exists in invoice, update qty
        const existingMealIdx = inv.meals.findIndex(m => m.name === newMealData.name);
        let updatedMeals = [...inv.meals];
        if (existingMealIdx > -1) {
          const m = updatedMeals[existingMealIdx];
          const newQty = m.quantity + newMealData.quantity;
          updatedMeals[existingMealIdx] = {
            ...m,
            quantity: newQty,
            subtotal: newQty * m.unitPrice
          };
        } else {
          updatedMeals.push({
            name: newMealData.name,
            quantity: newMealData.quantity,
            unitPrice: newMealData.price,
            subtotal: newMealData.total
          });
        }

        const newAmount = updatedMeals.reduce((acc, curr) => acc + curr.subtotal, 0);
        const newTax = newAmount * 0.085;
        const newTotal = newAmount + newTax + inv.fees;

        return {
          ...inv,
          meals: updatedMeals,
          amount: newAmount,
          tax: newTax,
          total: newTotal,
          status: "Pending"
        };
      }
      return inv;
    }));

    toast.success("Order placed successfully.");
  };

  // 4. Reordering a meal
  const handleOrderAgainClick = (order) => {
    const mealItem = availableMeals.find(m => m.name === order.name) || availableMeals[0];
    if (mealItem) {
      setPreselectedMeal(mealItem);
      setAddOrderModalOpen(true);
    } else {
      toast.error("No active meal plans found to order this item again.");
    }
  };

  // 5. Viewing order details from API using raw_order_id
  const handleViewOrderDetails = (ord) => {
    setSelectedOrderForDetails(ord);
    setDetailsDrawerOpen(true);
    const orderId = ord.raw?.raw_order_id || ord.raw_order_id;
    if (orderId) {
      dispatch(getOrderDetail({ token: customerId, orderId }));
    }
  };

  // Viewing invoice details from API using raw_bill_id
  const handleViewInvoiceDetails = (inv) => {
    setSelectedInvoiceForDetails(inv);
    setInvoiceModalOpen(true);
    const billId = inv.raw_bill_id;
    if (billId) {
      dispatch(getBillDetail({ token: customerId, billId }));
    }
  };

  // 5. Download invoice receipt via POST API
  const handleDownloadInvoice = (invoiceId, invObj = null) => {
    const inv = invObj || billDetailData || selectedInvoiceForDetails || invoices.find(i => (i.bill_unique_id || i.id) === invoiceId);

    const rawBillId = inv?.raw_bill_id || inv?.bill_id || inv?.id || invoiceId;
    if (!rawBillId) {
      toast.error("Invoice ID not found.");
      return;
    }

    const toastId = toast.loading("Downloading invoice PDF...");

    dispatch(
      downloadOrderBillPdf({
        token: customerId,
        billId: rawBillId,
        format: "standard",
        stream: 0,
      })
    )
      .unwrap()
      .then((res) => {
        const fileUrl = res?.data?.file_url;
        const fileName = res?.data?.file_name || `invoice_${rawBillId}.pdf`;

        if (fileUrl) {
          toast.success("Invoice PDF downloaded successfully!", { id: toastId });
          const link = document.createElement("a");
          link.href = fileUrl;
          link.setAttribute("download", fileName);
          link.setAttribute("target", "_blank");
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          toast.error(res?.message || "Invoice PDF URL not found.", { id: toastId });
        }
      })
      .catch((err) => {
        console.error("PDF download error:", err);
        const errMsg = typeof err === "string" ? err : (err?.message || "Failed to download invoice PDF.");
        toast.error(errMsg, { id: toastId });
      });
  };

  // --- Filtering & Sorting & Pagination Logic ---

  // Tab 1 Today's Orders
  const filteredTodayOrders = todayOrders.filter((order) => {
    // 1. Search Query
    const searchMatch =
      order.name.toLowerCase().includes(todaySearch.toLowerCase()) ||
      order.id.toLowerCase().includes(todaySearch.toLowerCase()) ||
      order.category.toLowerCase().includes(todaySearch.toLowerCase());

    if (!searchMatch) return false;

    // 2. Toolbar Category Filter
    if (todayFilter !== "all") {
      if (["Lunch", "Dinner"].includes(todayFilter)) {
        return order.category === todayFilter;
      }
      if (todayFilter === "Delivered") {
        return order.status === "Delivered" || order.status === "Confirmed";
      }
      return order.status === todayFilter; // Filter by status Confirmed, Pending, Cancelled
    }

    return true;
  });

  // Sort Today's Orders
  const sortedTodayOrders = [...filteredTodayOrders].sort((a, b) => {
    if (todaySort === "newest") {
      return b.id.localeCompare(a.id); // higher ORD ID represents newer in our mock
    }
    if (todaySort === "oldest") {
      return a.id.localeCompare(b.id);
    }
    if (todaySort === "quantity") {
      return b.quantity - a.quantity;
    }
    if (todaySort === "price") {
      return b.total - a.total;
    }
    return 0;
  });

  const isCutoffPassed = (category) => {
    const cutoffStr = category?.toLowerCase() === "dinner" ? dinnerCutoffTime : lunchCutoffTime;
    if (!cutoffStr) return true;
    const [ch, cm] = cutoffStr.split(":").map(Number);
    const now = new Date();
    const cutoff = new Date();
    cutoff.setHours(ch, cm, 0, 0);
    return now.getTime() >= cutoff.getTime();
  };

  // Split Today's Orders into Lunch and Dinner sections
  const lunchOrders = sortedTodayOrders.filter((o) => {
    const cat = (o.category || o.raw?.meal_type || "").toLowerCase();
    return cat === "lunch" || cat.includes("lunch") || (!cat.includes("dinner") && cat !== "dinner");
  });

  const dinnerOrders = sortedTodayOrders.filter((o) => {
    const cat = (o.category || o.raw?.meal_type || "").toLowerCase();
    return cat === "dinner" || cat.includes("dinner");
  });

  const hasActiveLunchOrders = lunchOrders.some((o) => o.status !== "Cancelled" && o.status !== "Canceled");
  const hasActiveDinnerOrders = dinnerOrders.some((o) => o.status !== "Cancelled" && o.status !== "Canceled");

  const TODAY_PAGE_SIZE = 10;
  const totalLunchPages = Math.ceil(lunchOrders.length / TODAY_PAGE_SIZE);
  const paginatedLunchOrders = lunchOrders.slice(
    (lunchPage - 1) * TODAY_PAGE_SIZE,
    lunchPage * TODAY_PAGE_SIZE
  );

  const totalDinnerPages = Math.ceil(dinnerOrders.length / TODAY_PAGE_SIZE);
  const paginatedDinnerOrders = dinnerOrders.slice(
    (dinnerPage - 1) * TODAY_PAGE_SIZE,
    dinnerPage * TODAY_PAGE_SIZE
  );

  // Tab 2 History Orders
  const baseHistoryList = orderHistory;
  const filteredHistoryOrders = baseHistoryList.filter((order) => {
    // 1. Search
    const searchMatch =
      (order.name || "").toLowerCase().includes(historySearch.toLowerCase()) ||
      (order.id || "").toLowerCase().includes(historySearch.toLowerCase());

    if (!searchMatch) return false;

    // 2. Subtab Filter (All, Pending, Completed, Cancelled)
    if (historySubtab !== "all") {
      if (historySubtab === "completed") {
        if (order.status !== "Completed" && order.status !== "Delivered") return false;
      } else if (historySubtab === "cancelled") {
        if (order.status !== "Cancelled" && order.status !== "Canceled") return false;
      } else {
        const targetStatus = historySubtab.charAt(0).toUpperCase() + historySubtab.slice(1);
        if (order.status !== targetStatus) return false;
      }
    }

    // 3. Toolbar Category Filter
    if (historyFilter !== "all") {
      if (order.category !== historyFilter) return false;
    }

    // 4. Date Range
    const orderNormDate = order.normalizedDate || normalizeDateStr(order.orderDate);
    if (historyDateRange.start) {
      const normStart = normalizeDateStr(historyDateRange.start);
      if (orderNormDate < normStart) return false;
    }
    if (historyDateRange.end) {
      const normEnd = normalizeDateStr(historyDateRange.end);
      if (orderNormDate > normEnd) return false;
    }

    return true;
  });

  // Sort History
  const sortedHistoryOrders = [...filteredHistoryOrders].sort((a, b) => {
    if (historySort === "newest") {
      return (b.orderDate || "").localeCompare(a.orderDate || "");
    }
    if (historySort === "oldest") {
      return (a.orderDate || "").localeCompare(a.orderDate || "");
    }
    if (historySort === "quantity") {
      return b.quantity - a.quantity;
    }
    if (historySort === "price") {
      return b.total - a.total;
    }
    return 0;
  });

  const HISTORY_PAGE_SIZE = ordersMeta?.perPage || 15;
  const totalHistoryPages = ordersMeta?.lastPage || Math.ceil(sortedHistoryOrders.length / HISTORY_PAGE_SIZE);
  const paginatedHistoryOrders = activeTab === 2 && ordersMeta
    ? sortedHistoryOrders
    : sortedHistoryOrders.slice(
      (historyPage - 1) * HISTORY_PAGE_SIZE,
      historyPage * HISTORY_PAGE_SIZE
    );

  const SUBS_PAGE_SIZE = 10;
  const displayMealPlans = mealPlansData || [];
  const totalSubsPages = Math.ceil(displayMealPlans.length / SUBS_PAGE_SIZE);
  const paginatedMealPlans = displayMealPlans.slice(
    (subscriptionsPage - 1) * SUBS_PAGE_SIZE,
    subscriptionsPage * SUBS_PAGE_SIZE
  );

  // Invoice calculations
  const displayBills = billsData && billsData.length > 0 ? billsData : invoices;

  const totalPaidAmount = displayBills.reduce((sum, inv) => {
    const total = inv.total_amount !== undefined ? Number(inv.total_amount) : Number(inv.amount || 0);
    let paid = 0;
    if (inv.paid_amount !== undefined && inv.paid_amount !== null && !isNaN(Number(inv.paid_amount))) {
      paid = Number(inv.paid_amount);
    } else if (inv.status?.toLowerCase() === "paid") {
      paid = total;
    }
    return sum + paid;
  }, 0);

  const completedPaymentsCount = displayBills.filter(i => i.status?.toLowerCase() === "paid").length;

  const pendingInvoicesSum = displayBills.reduce((sum, inv) => {
    const total = inv.total_amount !== undefined ? Number(inv.total_amount) : Number(inv.amount || 0);
    let paid = 0;
    if (inv.paid_amount !== undefined && inv.paid_amount !== null && !isNaN(Number(inv.paid_amount))) {
      paid = Number(inv.paid_amount);
    } else if (inv.status?.toLowerCase() === "paid") {
      paid = total;
    }

    let due = 0;
    if (inv.due_amount !== undefined && inv.due_amount !== null && !isNaN(Number(inv.due_amount))) {
      due = Number(inv.due_amount);
    } else if (inv.pending_amount !== undefined && inv.pending_amount !== null && !isNaN(Number(inv.pending_amount))) {
      due = Number(inv.pending_amount);
    } else {
      due = Math.max(0, total - paid);
    }
    return sum + due;
  }, 0);

  const INVOICE_PAGE_SIZE = 10;
  const totalInvoicePages = Math.ceil(displayBills.length / INVOICE_PAGE_SIZE);
  const paginatedInvoices = displayBills.slice(
    (invoicesPage - 1) * INVOICE_PAGE_SIZE,
    invoicesPage * INVOICE_PAGE_SIZE
  );

  const orderDetailNormalized = orderDetailData ? {
    ...orderDetailData,
    status: orderDetailData.status ? orderDetailData.status.charAt(0).toUpperCase() + orderDetailData.status.slice(1) : ""
  } : null;

  if (isCustomerLoading) {
    return (
      <div className="min-h-screen md:fixed md:inset-0 bg-gradient-to-tr from-[#F8F7F4] via-[#F4F3EF] to-[#FAF9F6] text-text-primary antialiased font-sans selection:bg-brand-red-light selection:text-brand-red flex flex-col justify-between p-3 sm:p-4 lg:p-6 overflow-y-auto md:overflow-hidden overflow-x-hidden animate-fade-in">
        <EnvironmentTag />

        {/* Decorative Background Circles */}
        <div className="hidden md:block absolute -top-32 -left-32 w-80 h-80 rounded-full bg-[#FCE8E6]/60 pointer-events-none -z-10" />
        <div className="hidden md:block absolute -bottom-48 -right-48 w-[400px] h-[400px] rounded-full bg-[#FFF0E6]/70 pointer-events-none -z-10" />

        {/* Main Centered Wrapper */}
        <div className="flex-1 w-full max-w-7xl mx-auto flex flex-col justify-center overflow-visible md:overflow-hidden px-0 sm:px-4 lg:px-8 py-2 md:py-0">
          {/* White Card Container */}
          <div className="w-full bg-white rounded-2xl border border-border-primary/80 p-3 sm:p-6 lg:p-8 h-auto md:h-[82vh] md:min-h-[600px] md:max-h-[850px] flex flex-col overflow-hidden shadow-xl">
            <PageSkeleton />
          </div>
        </div>

        <footer className="w-full mt-4 mb-2 text-center shrink-0">
          <a href="http://tiffintap.com" target="_blank" rel="noopener noreferrer" className="text-[11px] font-medium text-text-muted">
            Powered by <span className="font-semibold text-orange-500">tiffintap</span>
          </a>
        </footer>
      </div>
    );
  }

  return (
    <div className="min-h-screen md:fixed md:inset-0 bg-gradient-to-tr from-[#F8F7F4] via-[#F4F3EF] to-[#FAF9F6] text-text-primary antialiased font-sans selection:bg-brand-red-light selection:text-brand-red flex flex-col justify-between p-3 sm:p-4 lg:p-6 overflow-y-auto md:overflow-hidden overflow-x-hidden">
      <EnvironmentTag />

      {/* Decorative Background Circles */}
      <div className="hidden md:block absolute -top-32 -left-32 w-80 h-80 rounded-full bg-[#FCE8E6]/60 pointer-events-none -z-10" />
      <div className="hidden md:block absolute -bottom-48 -right-48 w-[400px] h-[400px] rounded-full bg-[#FFF0E6]/70 pointer-events-none -z-10" />

      {/* Main Centered Wrapper */}
      <div className="flex-1 w-full max-w-7xl mx-auto flex flex-col justify-center overflow-visible md:overflow-hidden px-0 sm:px-4 lg:px-8 py-2 md:py-0">

        {/* White Card Container */}
        <div className="w-full bg-white rounded-2xl border border-border-primary/80 p-3 sm:p-6 lg:p-8 h-auto md:h-[82vh] md:min-h-[600px] md:max-h-[850px] flex flex-col overflow-hidden shadow-xl">

          {/* 1. Provider & Customer Information Panel */}
          <CustomerProviderCard
            provider={provider}
            customer={customer}
            onVerifyClick={() => setVerifyModalOpen(true)}
          />

          {/* MAIN TAB NAVIGATION */}
          <div className="flex  border-b border-border-primary mb-6 gap-6 sm:gap-8 px-2   flex-wrap w-full">

            <button
              onClick={() => { setActiveTab(1); }}
              className={`flex items-center space-x-2 py-3 px-1 text-sm font-semibold transition-all cursor-pointer border-b-2 shrink-0 outline-none focus:outline-none ${activeTab === 1
                ? "border-brand-red text-brand-red font-bold"
                : "border-transparent text-text-secondary hover:text-text-primary"
                }`}
            >
              <TodaysOrderCustomIcon className="w-4 h-4 shrink-0" />
              <span>Today's Order</span>
              {todayOrders.filter(o => o.status !== "Cancelled").length > 0 && (
                <span className={`w-5 h-5 flex items-center justify-center rounded-full text-[10px] leading-none font-bold transition-colors ${activeTab === 1
                  ? "bg-brand-red text-white"
                  : "bg-bg-secondary text-text-secondary"
                  }`}>
                  {todayOrders.filter(o => o.status !== "Cancelled").length}
                </span>
              )}
            </button>

            <button
              onClick={() => { setActiveTab(2); }}
              className={`flex items-center space-x-2 py-3 px-1 text-sm font-semibold transition-all cursor-pointer border-b-2 shrink-0 outline-none focus:outline-none ${activeTab === 2
                ? "border-brand-red text-brand-red font-bold"
                : "border-transparent text-text-secondary hover:text-text-primary"
                }`}
            >
              <Calendar className="w-4 h-4 shrink-0" />
              <span>Order History</span>
            </button>

            <button
              onClick={() => { setActiveTab(3); }}
              className={`flex items-center space-x-2 py-3 px-1 text-sm font-semibold transition-all cursor-pointer border-b-2 shrink-0 outline-none focus:outline-none ${activeTab === 3
                ? "border-brand-red text-brand-red font-bold"
                : "border-transparent text-text-secondary hover:text-text-primary"
                }`}
            >
              <Star className="w-4 h-4 shrink-0" />
              <span>Subscription Plans</span>
            </button>

            <button
              onClick={() => { setActiveTab(4); }}
              className={`flex items-center space-x-2 py-3 px-1 text-sm font-semibold transition-all cursor-pointer border-b-2 shrink-0 outline-none focus:outline-none ${activeTab === 4
                ? "border-brand-red text-brand-red font-bold"
                : "border-transparent text-text-secondary hover:text-text-primary"
                }`}
            >
              <InvoiceCustomIcon className="w-4 h-4 shrink-0" />
              <span>Invoice</span>
            </button>

          </div>

          {/* TAB CONTENTS */}
          <div className="flex-1 overflow-visible md:overflow-y-auto pr-1 min-h-0">

            {/* ============================================================== */}
            {/* TAB 1: TODAY'S ORDERS */}
            {/* ============================================================== */}
            {activeTab === 1 && (
              <div className="space-y-6">

                {/* Tab Header row */}
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                  <div>
                    <h2 className="text-xl font-bold text-text-primary font-display">Today's Order</h2>
                    <p className="text-xs text-text-secondary mt-0.5">Manage and review your meal slots for today.</p>
                  </div>

                  <div className="flex items-center gap-3 w-full sm:w-auto">
                    <span className="text-xs text-text-secondary font-semibold font-mono bg-white border border-border-primary px-3 py-2 rounded-lg block text-center shrink-0">
                      {currentDateFormatted}
                    </span>
                  </div>
                </div>

                {/* Subtab Segmented Navigation for Today's Order (Lunch & Dinner) */}
                <div className="flex bg-bg-secondary p-1 rounded-lg border border-border-primary w-full sm:w-fit overflow-x-auto scrollbar-none flex-nowrap max-w-full gap-1">
                  <button
                    onClick={() => setTodaySubtab("lunch")}
                    className={`flex items-center space-x-2 px-4 py-1.5 rounded-md text-xs font-bold transition-all cursor-pointer outline-none focus:outline-none focus:ring-0 select-none ${todaySubtab === "lunch"
                      ? "bg-white text-brand-red shadow-xs"
                      : "text-text-secondary hover:text-text-primary"
                      }`}
                  >
                    <LunchSunIcon className="w-3.5 h-3.5" />
                    <span>Lunch</span>
                    <span className={`px-1.5 py-0.2 rounded-full text-[10px] font-extrabold ${todaySubtab === "lunch"
                      ? "bg-brand-red/10 text-brand-red"
                      : "bg-gray-200 text-text-secondary"
                      }`}>
                      {lunchOrders.length}
                    </span>
                  </button>

                  <button
                    onClick={() => setTodaySubtab("dinner")}
                    className={`flex items-center space-x-2 px-4 py-1.5 rounded-md text-xs font-bold transition-all cursor-pointer outline-none focus:outline-none focus:ring-0 select-none ${todaySubtab === "dinner"
                      ? "bg-white text-brand-red shadow-xs"
                      : "text-text-secondary hover:text-text-primary"
                      }`}
                  >
                    <DinnerMoonIcon className="w-3.5 h-3.5" />
                    <span>Dinner</span>
                    <span className={`px-1.5 py-0.2 rounded-full text-[10px] font-extrabold ${todaySubtab === "dinner"
                      ? "bg-brand-red/10 text-brand-red"
                      : "bg-gray-200 text-text-secondary"
                      }`}>
                      {dinnerOrders.length}
                    </span>
                  </button>
                </div>

                {/* Today Orders Listing */}
                {isOrdersLoading ? (
                  <div className="space-y-6">
                    <div className="space-y-3">
                      <div className="flex items-center justify-between">
                        <h3 className="text-xs font-black text-text-secondary uppercase tracking-wider">
                          {todaySubtab === "lunch" ? "Lunch Orders" : "Dinner Orders"}
                        </h3>
                      </div>
                      <OrdersTableSkeleton isHistoryView={false} isUpcomingTable={true} rows={2} />
                    </div>
                  </div>
                ) : sortedTodayOrders.length === 0 ? (
                  <div className="bg-white border border-border-primary rounded-xl p-12 text-center shadow-xs">
                    <div className="w-14 h-14 rounded-full bg-bg-secondary flex items-center justify-center mx-auto mb-4 border border-border-primary">
                      <ShoppingBag className="w-6 h-6 text-text-secondary" />
                    </div>
                    <h3 className="text-base font-bold text-text-primary leading-tight">No orders for today</h3>
                    <p className="text-xs text-text-secondary mt-1 max-w-sm mx-auto leading-relaxed">
                      Your scheduled meals for today will appear here. No active orders are currently found on your account.
                    </p>
                  </div>
                ) : (
                  <div className="space-y-6">
                    {/* Lunch Orders Section */}
                    {todaySubtab === "lunch" && (
                      <div className="space-y-3">
                        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 pb-1 border-b border-border-primary/40">
                          <div className="flex items-center gap-2">
                            <LunchSunIcon className="w-4 h-4 text-amber-700 shrink-0" />
                            <h3 className="text-sm font-extrabold text-text-primary uppercase tracking-wider font-display">Lunch Orders</h3>
                            <span className="px-2 py-0.5 rounded-full text-[10px] font-bold bg-amber-50 text-amber-800 border border-amber-200/80">
                              {lunchOrders.length} {lunchOrders.length === 1 ? "Meal" : "Meals"}
                            </span>
                          </div>

                          {/* Compact & Premium Cutoff Timer Widget */}
                          <div className="flex items-center gap-2 bg-amber-50/70 border border-amber-200/60 px-3 py-1.5 rounded-xl shadow-2xs">
                            {hasActiveLunchOrders && !isLunchPassed && <Clock className="w-3.5 h-3.5 text-amber-600 shrink-0 animate-pulse" />}
                            {(!hasActiveLunchOrders || isLunchPassed) && <Clock className="w-3.5 h-3.5 text-amber-600/70 shrink-0" />}
                            <span className={`text-[11px] font-semibold ${hasActiveLunchOrders && !isLunchPassed ? "text-red-500 animate-pulse" : "text-amber-800"}`}>
                              Lunch Cutoff ({formatCutoffTime(lunchCutoffTime)}):
                            </span>
                            <span className={`text-xs font-mono font-extrabold px-2 py-0.5 rounded-md ${!hasActiveLunchOrders
                              ? "bg-gray-100 text-text-secondary border border-border-primary"
                              : isLunchPassed
                                ? "bg-red-100 text-red-700 border border-red-200"
                                : "bg-white text-amber-900 border border-amber-300 shadow-2xs"
                              }`}>
                              {!hasActiveLunchOrders ? "No More Orders" : isLunchPassed ? "Cutoff Passed" : lunchTimeLeft}
                            </span>
                            <div className="relative group/info ml-0.5">
                              <Info className="w-3.5 h-3.5 text-amber-700/70 hover:text-amber-800 cursor-pointer transition-colors" />
                              <div className="absolute right-0 bottom-full mb-2 hidden group-hover/info:block w-64 bg-gray-900 text-white text-[10px] p-2.5 rounded-lg shadow-lg z-50 text-left normal-case tracking-normal font-medium leading-normal animate-fade-in">
                                Lunch orders can be cancelled until {formatCutoffTime(lunchCutoffTime)}. Cancellations are locked after cutoff time.
                                <div className="absolute top-full right-[5px] border-4 border-transparent border-t-gray-900"></div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {lunchOrders.length > 0 ? (
                          <>
                            <OrdersTable
                              orders={paginatedLunchOrders}
                              onViewDetailsClick={handleViewOrderDetails}
                              onCancelClick={(ord) => {
                                setSelectedOrderForCancel(ord);
                                setCancelModalOpen(true);
                              }}
                              isHistoryView={false}
                              isCustomerVerified={customer.isVerified}
                              isUpcomingTable={true}
                              lunchCutoffTime={lunchCutoffTime}
                              dinnerCutoffTime={dinnerCutoffTime}
                              showRowCutoff={false}
                              currencySymbol={provider.currencySymbol}
                            />
                            {renderPaginationControls(lunchPage, totalLunchPages, setLunchPage)}
                          </>
                        ) : (
                          <div className="bg-white border border-border-primary/80 rounded-xl p-5 text-center shadow-2xs">
                            <div className="w-8 h-8 rounded-full bg-amber-50 text-amber-600 flex items-center justify-center mx-auto mb-2 border border-amber-200/60">
                              <LunchSunIcon className="w-4 h-4" />
                            </div>
                            <h4 className="text-xs font-bold text-text-primary">No lunch orders for today</h4>
                            <p className="text-[11px] text-text-secondary mt-0.5">
                              Your scheduled lunch meals for today will appear here.
                            </p>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Dinner Orders Section */}
                    {todaySubtab === "dinner" && (
                      <div className="space-y-3">
                        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 pb-1 border-b border-border-primary/40">
                          <div className="flex items-center gap-2">
                            <DinnerMoonIcon className="w-4 h-4 text-indigo-600 shrink-0" />
                            <h3 className="text-sm font-extrabold text-text-primary uppercase tracking-wider font-display">Dinner Orders</h3>
                            <span className="px-2 py-0.5 rounded-full text-[10px] font-bold bg-indigo-50 text-indigo-800 border border-indigo-200/80">
                              {dinnerOrders.length} {dinnerOrders.length === 1 ? "Meal" : "Meals"}
                            </span>
                          </div>

                          {/* Compact & Premium Cutoff Timer Widget */}
                          <div className="flex items-center gap-2 bg-indigo-50/60 border border-indigo-200/60 px-3 py-1.5 rounded-xl shadow-2xs">
                            {hasActiveDinnerOrders && !isDinnerPassed && <Clock className="w-3.5 h-3.5 text-indigo-600 shrink-0 animate-pulse" />}
                            {(!hasActiveDinnerOrders || isDinnerPassed) && <Clock className="w-3.5 h-3.5 text-indigo-600/70 shrink-0" />}
                            <span className={`text-[11px] font-semibold ${hasActiveDinnerOrders && !isDinnerPassed ? "text-red-500 animate-pulse" : "text-indigo-800"}`}>
                              Dinner Cutoff ({formatCutoffTime(dinnerCutoffTime)}):
                            </span>
                            <span className={`text-xs font-mono font-extrabold px-2 py-0.5 rounded-md ${!hasActiveDinnerOrders
                              ? "bg-gray-100 text-text-secondary border border-border-primary"
                              : isDinnerPassed
                                ? "bg-red-100 text-red-700 border border-red-200"
                                : "bg-white text-indigo-900 border border-indigo-300 shadow-2xs"
                              }`}>
                              {!hasActiveDinnerOrders ? "No More Orders" : isDinnerPassed ? "Cutoff Passed" : dinnerTimeLeft}
                            </span>
                            <div className="relative group/info ml-0.5">
                              <Info className="w-3.5 h-3.5 text-indigo-700/70 hover:text-indigo-800 cursor-pointer transition-colors" />
                              <div className="absolute right-0 bottom-full mb-2 hidden group-hover/info:block w-64 bg-gray-900 text-white text-[10px] p-2.5 rounded-lg shadow-lg z-50 text-left normal-case tracking-normal font-medium leading-normal animate-fade-in">
                                Dinner orders can be cancelled until {formatCutoffTime(dinnerCutoffTime)}. Cancellations are locked after cutoff time.
                                <div className="absolute top-full right-[5px] border-4 border-transparent border-t-gray-900"></div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {dinnerOrders.length > 0 ? (
                          <>
                            <OrdersTable
                              orders={paginatedDinnerOrders}
                              onViewDetailsClick={handleViewOrderDetails}
                              onCancelClick={(ord) => {
                                setSelectedOrderForCancel(ord);
                                setCancelModalOpen(true);
                              }}
                              isHistoryView={false}
                              isCustomerVerified={customer.isVerified}
                              isUpcomingTable={true}
                              lunchCutoffTime={lunchCutoffTime}
                              dinnerCutoffTime={dinnerCutoffTime}
                              showRowCutoff={false}
                              currencySymbol={provider.currencySymbol}
                            />
                            {renderPaginationControls(dinnerPage, totalDinnerPages, setDinnerPage)}
                          </>
                        ) : (
                          <div className="bg-white border border-border-primary/80 rounded-xl p-5 text-center shadow-2xs">
                            <div className="w-8 h-8 rounded-full bg-indigo-50 text-indigo-600 flex items-center justify-center mx-auto mb-2 border border-indigo-200/60">
                              <DinnerMoonIcon className="w-4 h-4" />
                            </div>
                            <h4 className="text-xs font-bold text-text-primary">No dinner orders for today</h4>
                            <p className="text-[11px] text-text-secondary mt-0.5">
                              Your scheduled dinner meals for today will appear here.
                            </p>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

              </div>
            )}

            {/* ============================================================== */}
            {/* TAB 2: ORDER HISTORY */}
            {/* ============================================================== */}
            {activeTab === 2 && (
              <div className="space-y-6">
                <div>
                  <h2 className="text-xl font-bold text-text-primary font-display">Order History</h2>
                  <p className="text-xs text-text-secondary mt-0.5">View and audit your previous meal orders.</p>
                </div>

                {/* Subtab Segmented Navigation (All, Pending, Completed, Canceled) */}
                <div className="flex bg-bg-secondary p-1 rounded-lg border border-border-primary w-full sm:w-fit overflow-x-auto scrollbar-none flex-nowrap max-w-full gap-1">
                  {["all", "pending", "completed", "cancelled"].map((tab) => (
                    <button
                      key={tab}
                      onClick={() => { setHistorySubtab(tab); }}
                      className={`px-4 py-1.5 rounded-md text-xs font-bold capitalize transition-all cursor-pointer outline-none focus:outline-none focus:ring-0 select-none ${historySubtab === tab
                        ? "bg-white text-brand-red shadow-xs"
                        : "text-text-secondary hover:text-text-primary"
                        }`}
                    >
                      {tab}
                    </button>
                  ))}
                </div>

                {/* Toolbar */}
                <Toolbar
                  searchQuery={historySearch}
                  onSearchChange={setHistorySearch}
                  activeFilter={historyFilter}
                  onFilterChange={setHistoryFilter}
                  resultCount={ordersMeta?.total !== undefined && activeTab === 2 ? ordersMeta.total : filteredHistoryOrders.length}
                  showHistoryFilters={true}
                  dateRange={historyDateRange}
                  onDateRangeChange={setHistoryDateRange}
                />

                {/* Order History Listing */}
                {isOrdersLoading ? (
                  <OrdersTableSkeleton isHistoryView={true} isUpcomingTable={false} rows={5} />
                ) : paginatedHistoryOrders.length === 0 ? (
                  <div className="bg-white border border-border-primary rounded-xl p-12 text-center shadow-xs">
                    <h3 className="text-base font-bold text-text-primary">No previous orders yet.</h3>
                    <p className="text-xs text-text-secondary mt-1">Your past ordering activity will accumulate here.</p>
                  </div>
                ) : (
                  <>
                    <OrdersTable
                      orders={paginatedHistoryOrders}
                      onViewDetailsClick={handleViewOrderDetails}
                      onCancelClick={(ord) => {
                        setSelectedOrderForCancel(ord);
                        setCancelModalOpen(true);
                      }}
                      isHistoryView={true}
                      isCustomerVerified={customer.isVerified}
                      isScrollable={true}
                      lunchCutoffTime={lunchCutoffTime}
                      dinnerCutoffTime={dinnerCutoffTime}
                      currencySymbol={provider.currencySymbol}
                    />
                    {renderPaginationControls(historyPage, totalHistoryPages, setHistoryPage)}
                  </>
                )}

              </div>
            )}

            {/* ============================================================== */}
            {/* TAB 3: SUBSCRIPTION PLANS */}
            {/* ============================================================== */}
            {activeTab === 3 && (
              <div className="space-y-6">
                <div>
                  <h2 className="text-xl font-bold text-text-primary font-display">Subscription Plans</h2>
                  <p className="text-xs text-text-secondary mt-0.5">View and manage your active and upcoming meal subscription plans.</p>
                </div>

                {isMealPlansLoading ? (
                  <SubscriptionsTableSkeleton rows={4} />
                ) : !mealPlansData || mealPlansData.length === 0 ? (
                  <div className="bg-white border border-border-primary rounded-xl p-12 text-center shadow-xs">
                    <h3 className="text-base font-bold text-text-primary">No subscriptions available.</h3>
                    <p className="text-xs text-text-secondary mt-1">Active meal subscription plans will appear here.</p>
                  </div>
                ) : (
                  <>
                    <SubscriptionsTable
                      mealPlans={paginatedMealPlans}
                      onViewPlanClick={(plan) => {
                        dispatch(getMealPlanDetail({ token: customerId, mealPlanId: plan.raw_meal_plan_id }));
                        setSubscriptionsModalOpen(true);
                      }}
                    />
                    {renderPaginationControls(subscriptionsPage, totalSubsPages, setSubscriptionsPage)}
                  </>
                )}
              </div>
            )}

            {/* ============================================================== */}
            {/* TAB 4: INVOICES */}
            {/* ============================================================== */}
            {activeTab === 4 && (
              <div className="space-y-6">
                <div>
                  <h2 className="text-xl font-bold text-text-primary font-display">Invoice</h2>
                  <p className="text-xs text-text-secondary mt-0.5">View your bill payments and receipt logs.</p>
                </div>

                {/* Statistics Summary row */}
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                  {isBillsLoading ? (
                    <>
                      <StatCardSkeleton />
                      <StatCardSkeleton />
                      <StatCardSkeleton />
                    </>
                  ) : (
                    <>
                      {/* Stat 1 */}
                      <div className="bg-white p-4 rounded-xl border border-border-primary flex justify-between items-center transition-all hover:border-gray-300">
                        <div>
                          <span className="text-[10px] text-text-secondary uppercase font-bold tracking-wider block">Total Paid</span>
                          <span className="text-xl font-extrabold text-brand-red font-mono mt-1 block">{provider.currencySymbol}{totalPaidAmount.toFixed(2)}</span>
                        </div>
                        <div className="w-10 h-10 bg-success-bg/40 text-success rounded-lg flex items-center justify-center">
                          <CheckCircle2 className="w-5 h-5" />
                        </div>
                      </div>

                      {/* Stat 2 */}
                      <div className="bg-white p-4 rounded-xl border border-border-primary flex justify-between items-center transition-all hover:border-gray-300">
                        <div>
                          <span className="text-[10px] text-text-secondary uppercase font-bold tracking-wider block">Completed Payments</span>
                          <span className="text-xl font-extrabold text-text-primary font-mono mt-1 block">{completedPaymentsCount} Invoices</span>
                        </div>
                        <div className="w-10 h-10 bg-bg-secondary text-text-secondary border border-border-primary rounded-lg flex items-center justify-center">
                          <InvoiceCustomIcon className="w-5 h-5 text-brand-red" />
                        </div>
                      </div>

                      {/* Stat 3 */}
                      <div className="bg-white p-4 rounded-xl border border-border-primary flex justify-between items-center transition-all hover:border-gray-300">
                        <div>
                          <span className="text-[10px] text-text-secondary uppercase font-bold tracking-wider block">Pending Amount</span>
                          <span className="text-xl font-extrabold text-warning font-mono mt-1 block">{provider.currencySymbol}{pendingInvoicesSum.toFixed(2)}</span>
                        </div>
                        <div className="w-10 h-10 bg-warning-bg/40 text-warning rounded-lg flex items-center justify-center">
                          <Clock className="w-5 h-5" />
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* Invoice listing */}
                {isBillsLoading ? (
                  <InvoiceTableSkeleton rows={4} />
                ) : paginatedInvoices.length === 0 ? (
                  <div className="bg-white border border-border-primary rounded-xl p-12 text-center shadow-xs">
                    <h3 className="text-base font-bold text-text-primary">No invoices available.</h3>
                    <p className="text-xs text-text-secondary mt-1">Transaction slips will generate here upon orders.</p>
                  </div>
                ) : (
                  <>
                    <InvoiceTable
                      invoices={paginatedInvoices}
                      onViewInvoiceClick={handleViewInvoiceDetails}
                      onDownloadInvoiceClick={handleDownloadInvoice}
                      isScrollable={true}
                      currencySymbol={provider.currencySymbol}
                    />
                    {renderPaginationControls(invoicesPage, totalInvoicePages, setInvoicesPage)}
                  </>
                )}

              </div>
            )}
          </div> {/* End of TAB CONTENTS wrapper */}

        </div> {/* End of White Card Container */}
      </div> {/* End of Main Centered Wrapper */}

      <footer className="w-full mt-4 mb-2 text-center shrink-0">
        <a href="http://tiffintap.com" target="_blank" rel="noopener noreferrer" className="text-[11px] font-medium text-text-muted">
          Powered by <span className="font-semibold text-orange-500">tiffintap</span>
        </a>
      </footer>

      {/* ============================================================== */}
      {/* GLOBAL MODALS DEFINITIONS */}
      {/* ============================================================== */}

      {/* 1. Account verification modal */}
      <VerificationModal
        isOpen={verifyModalOpen}
        onClose={() => setVerifyModalOpen(false)}
        customerEmail={customer.email}
        token={customerId}
        onVerificationSuccess={handleVerificationSuccess}
      />

      {/* 2. Add New Order Modal */}
      <AddOrderModal
        isOpen={addOrderModalOpen}
        onClose={() => { setAddOrderModalOpen(false); setPreselectedMeal(null); }}
        menuItems={availableMeals}
        preselectedMeal={preselectedMeal}
        onAddOrderSubmit={handleAddOrderSubmit}
        currencySymbol={provider.currencySymbol}
      />

      {/* 3. Cancel Order Modal */}
      <CancelOrderModal
        isOpen={cancelModalOpen}
        onClose={() => { setCancelModalOpen(false); setSelectedOrderForCancel(null); }}
        order={selectedOrderForCancel}
        onCancelSubmit={handleCancelSubmit}
        currencySymbol={provider.currencySymbol}
      />

      {/* 4. Order Details Drawer (for historical views) */}
      <OrderDetailsDrawer
        isOpen={detailsDrawerOpen}
        onClose={() => { setDetailsDrawerOpen(false); setSelectedOrderForDetails(null); }}
        order={orderDetailNormalized || selectedOrderForDetails}
        isLoading={isOrderDetailLoading}
        isCustomerVerified={customer.isVerified}
        isOrderingClosed={timerMode === "closed"}
        onReorderClick={handleOrderAgainClick}
        currencySymbol={provider.currencySymbol}
      />

      {/* 5. Invoice Details Receipt Modal */}
      <InvoiceDetailsModal
        isOpen={invoiceModalOpen}
        onClose={() => { setInvoiceModalOpen(false); setSelectedInvoiceForDetails(null); }}
        invoice={billDetailData || selectedInvoiceForDetails}
        isLoading={isBillDetailLoading}
        provider={provider}
        customer={customer}
        onDownload={handleDownloadInvoice}
        currencySymbol={provider.currencySymbol}
      />

      {/* 6. Subscription Plans Detail Modal */}
      <MealPlanDetailModal
        isOpen={subscriptionsModalOpen}
        onClose={() => setSubscriptionsModalOpen(false)}
        plan={planDetailData}
        isLoading={isPlanDetailLoading}
        currencySymbol={provider.currencySymbol}
      />



    </div>
  );
}
